import type { ScopeChild, ScopeParent } from "@/lib/scope-switcher"
import { ADMIN_PROGRAMS } from "@/lib/mock/admin-directory"
import { isAllProgramsScope, readSchoolFamilyScope } from "@/hooks/use-active-scope"
import type { PrismEmbedScope } from "@/lib/prism-embed-scope"

const SCHOOL_ADDRESSES: Record<string, readonly string[]> = {
  jhu: ["733 N Broadway", "Baltimore, MD 21205", "United States"],
  mayo: ["200 First Street SW", "Rochester, MN 55905", "United States"],
}

function programDescription(programName: string, schoolName: string, credential: string): string {
  return `${programName} at ${schoolName}. Graduates earn the ${credential} credential through coursework, clinical education, and competency assessment.`
}

/** Build iframe scope for Program Details from the active school/program selection. */
export function buildProgramEmbedScope(
  parent: ScopeParent,
  child: ScopeChild | null,
): PrismEmbedScope {
  const familyScope = readSchoolFamilyScope()
  const allPrograms = isAllProgramsScope(familyScope)

  if (allPrograms || !child) {
    return {
      programName: "All programs",
      schoolName: parent.name,
      schoolLogo: parent.logo,
      description: `Institute-wide view across every licensed program at ${parent.name}.`,
      programType: "Hybrid",
      degreeOffered: "None",
      addressLines: [...(SCHOOL_ADDRESSES[parent.id] ?? ["United States"])],
    }
  }

  const record = ADMIN_PROGRAMS.find(
    program => program.id === child.id && program.schoolId === parent.id,
  )

  return {
    programName: child.name,
    schoolName: parent.name,
    schoolLogo: parent.logo,
    description: programDescription(
      child.name,
      parent.name,
      record?.credential ?? "program credential",
    ),
    programType: "Hybrid",
    degreeOffered: record?.credential ?? "None",
    addressLines: [...(SCHOOL_ADDRESSES[parent.id] ?? ["United States"])],
  }
}
